import type { SourceOfFundsData } from '@onramp/state/types/SourceOfFundsData';

export function getCryptoValueFromAccount(s?: SourceOfFundsData) {
  return Number(s?.limitData?.crypto?.value) || 0;
}
